export default __webpack_public_path__ + "static/media/Reorder.55ee8463.svg";